<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1">
      <!-- MainView -->
      <article class="wrapper wrapper-content main-column full-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_okr_on.png" alt="">
                {{ $t('termsServiceTitle') }}
            </h1>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight flex-option">
          <div class="ibox">
            <!-- <web-view-terms /> -->
            <web-view-terms-ja v-if="checkLanguage === 'ja'"/>
            <web-view-terms-en v-else-if="checkLanguage === 'en'" />
            <web-view-terms-zh v-else-if="checkLanguage === 'zh_tr'" />
          </div>
      </section>
    </article>
    </div>
  </div>
</template>

<script>
import {i18n} from '@/main'
// import WebViewTerms from '@/views/_webview/WebViewTerms'
import WebViewTermsJa from '@/views/_webview/WebViewTermsTrendmicroNgJA'
import WebViewTermsEn from '@/views/_webview/WebViewTermsTrendmicroNgEN'
import WebViewTermsZh from '@/views/_webview/WebViewTermsTrendmicroNgZH'

export default {
  name: 'Terms',
  components: {
    WebViewTermsJa,
    WebViewTermsEn,
    WebViewTermsZh
  },
  data: function () {
    return {
    }
  },
  computed: {
    checkLanguage () {
      return i18n.locale
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column-reverse;
  }
  section div{
    height: 100%;
    padding: 0.8em 1em 5em;
    overflow: visible;
  }
 section div >>> .app { overflow: visible; }
  .main-column {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/webview/TermsTrendmicroNg.vue